import React from "react";
import NewNavbar from "../../Components/newNavbar/NewNavbar";
import Footer from "../../Components/footer/Footer";
import NavbarLogo from "../../assets/evacassets/image/logo.png";
import { CButton, CCol, CContainer, CRow } from "@coreui/react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import OutSideNavBar from "../outsideNavBar/OutSideNavBar";

const PrivacyPolicy = () => {
  const nav = useNavigate();
  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div className="min-h-screen w-full bg-White">
      <OutSideNavBar />

      <main className=" custom-container my-5 flex-grow-1 text-start">
        {/* <h1 className="fw-bold fs-2 mb-2 text-dark">Privacy Policy</h1> */}
        <h1 className="fw-bold">Privacy Policy</h1>
        <p className="mb-4">Last Updated April 08, 2021</p>

        <section className="mb-4">
          <h4 className="font-semibold">Information Collection</h4>
          <p>
            We collect various types of information to provide better services
            to all our users. This includes:
          </p>
          <ul className="ps-4 mt-2">
            <li>Personal information (e.g., name, email, phone number)</li>
            <li>Usage data (e.g., how you interact with our services)</li>
            <li>Cookies and tracking technologies</li>
          </ul>
        </section>

        <section className="mb-4">
          <h4 className="font-semibold">Data Protection</h4>
          <p>
            We implement strict security measures to protect your personal
            information. We regularly review our security practices and take all
            reasonable precautions to safeguard your data against unauthorized
            access.
          </p>
        </section>

        <section className="mb-4">
          <h4 className="font-semibold">User Rights</h4>
          <p>
            You have the right to access, correct, or delete your personal data.
            If you wish to exercise these rights, please contact us at{" "}
            <a
              href="mailto:sales@pyramidelectronics.in"
              className="text-decoration-none"
            >
              sales@pyramidelectronics.in
            </a>
            .
          </p>
        </section>

        <section className="mb-4">
          <h4 className="font-semibold">Data Retention</h4>
          <p>
            We will retain your personal information only for as long as is
            necessary for the purposes set out in this Privacy Policy. After
            this period, your data will be securely deleted or anonymized.
          </p>
        </section>

        <section className="mb-4">
          <h4 className="font-semibold">Third-Party Sharing</h4>
          <p>
            We do not sell or share your personal information with third parties
            for marketing purposes. However, we may share data with trusted
            service providers for operational purposes, all while ensuring they
            adhere to the same data protection standards.
          </p>
        </section>

        <section>
          <h4 className="font-semibold">Cookies and Tracking Technologies</h4>
          <p>
            We use cookies and similar tracking technologies to enhance your
            experience on our platform. You can manage your preferences through
            your browser settings. Disabling cookies may limit certain
            functionalities of our services.
          </p>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
